import { useGoogleLogin } from "@react-oauth/google";

export const useLoginWithGoogle = ({ onSuccessCallback }) => {
  const login = useGoogleLogin({
    onSuccess: (user) => {
      onSuccessCallback(user);
    },
  });

  return login;
};
